export default "/images/06 Step2Plan-Provider-To select goals-01.png?1e35139454d5d49e396d9204ca6331bc";